import React from "react";
import { Link } from "react-router-dom";

// Tile clickable de estado de un servicio. Reutiliza el look de `esen-stat`
// y agrega un ícono, un chip de estado opcional y una barra `esen-meter`.
//
// Props:
//   to        ruta interna
//   icon      ícono Font Awesome
//   titulo    nombre del servicio
//   valor     valor principal (ej. "$120.00", "3", "3.7"). Opcional: si se
//             omite, el tile funciona como acceso directo sin métrica.
//   detalle   texto secundario bajo el valor
//   chip      { texto, tono }  tono: success | warning | danger | info
//   meter     { porcentaje, tono }  barra de progreso 0-100 (opcional)
const DashTile = ({ to, icon, titulo, valor, detalle, chip, meter }) => (
    <Link to={to} className="esen-stat esen-tile">
        <span className="esen-tile-icon">
            <i className={`fa ${icon}`} aria-hidden="true"></i>
        </span>
        <div className="esen-tile-body">
            <div className="esen-tile-head">
                <span className="esen-tile-titulo">{titulo}</span>
                {chip ? (
                    <span className={`esen-chip esen-chip--${chip.tono || "neutral"}`}>
                        {chip.texto}
                    </span>
                ) : null}
            </div>
            {valor !== undefined && valor !== null && valor !== "" ? (
                <div className="esen-stat-value">{valor}</div>
            ) : null}
            {detalle ? <div className="esen-stat-label">{detalle}</div> : null}
            {meter ? (
                <div className="esen-meter mt-2">
                    <div className="esen-meter-track">
                        <div
                            className={`esen-meter-fill${meter.tono ? ` esen-meter-fill--${meter.tono}` : ""}`}
                            style={{ width: `${Math.max(0, Math.min(100, meter.porcentaje))}%` }}
                        ></div>
                    </div>
                </div>
            ) : null}
        </div>
        <i className="fa fa-angle-right esen-tile-chevron" aria-hidden="true"></i>
    </Link>
);

export default DashTile;
